import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  .timezone-country-select.ant-select-outlined:not(.ant-select-customize-input)
    .ant-select-selector {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #374151 !important;
  }

  .timezone-country-select.ant-select-outlined:not(.ant-select-customize-input)
    .ant-select-selector:hover {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1px solid rgba(227, 110, 0, 0.4) !important;
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.15) !important;
    transform: translateY(-2px) !important;
  }

  .timezone-country-select.ant-select-focused
    .ant-select-selector {
    background: rgba(255, 255, 255, 0.98) !important;
    border: 2px solid #e36e00 !important;
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.2) !important;
    transform: translateY(-2px) !important;
  }

  .timezone-country-select .ant-select-selection-placeholder {
    color: #9ca3af !important;
    font-weight: 400 !important;
  }

  .timezone-country-select .ant-select-arrow {
    color: #e36e00 !important;
    transition: all 0.3s ease !important;
  }

  .timezone-country-select.ant-select:hover .ant-select-arrow {
    color: #ffae00 !important;
    transform: scale(1.1) !important;
  }

  .timezone-country-select .ant-select-clear {
    color: #e36e00 !important;
    background: rgba(227, 110, 0, 0.1) !important;
    border-radius: 50% !important;
    transition: all 0.3s ease !important;
  }

  .timezone-country-select .ant-select-clear:hover {
    color: #ffae00 !important;
    background: rgba(227, 110, 0, 0.2) !important;
    transform: scale(1.1) !important;
  }

  .timezone-country-dropdown.ant-select-dropdown {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
    max-height: 320px !important;
    overflow-y: auto !important;
    padding: 8px 0 10px !important;
  }

  .timezone-country-dropdown .ant-select-item {
    min-height: 36px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #374151 !important;
    transition: all 0.3s ease !important;
    border-radius: 8px !important;
    margin: 2px 8px !important;
  }

  .timezone-country-dropdown .ant-select-item:hover {
    background: rgba(227, 110, 0, 0.1) !important;
    color: #e36e00 !important;
    transform: translateX(4px) !important;
  }

  .timezone-country-dropdown .ant-select-item-option-content {
    min-width: 0;
    width: 100%;
  }

  .timezone-country-dropdown .ant-select-item:last-child {
    margin-bottom: 8px !important;
  }

  .timezone-country-dropdown .ant-select-item-option-selected {
    background: rgba(227, 110, 0, 0.15) !important;
    color: #e36e00 !important;
    font-weight: 600 !important;
  }

  .timezone-country-dropdown .ant-select-item-option-active {
    background: rgba(227, 110, 0, 0.1) !important;
    color: #e36e00 !important;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
